import { Link } from 'react-router-dom';
import 'twin.macro';

export const SidebarNavLink = ({ to, children, text = children }) => (
  <Link to={to}>
    <div tw='block p-1.5'>{children}</div>
  </Link>
);
